// THIS FILE IS NO LONGER USED!
// USE utils/dates.ts INSTEAD.

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export const dateToUTC = (date: Date, dateTimezone?: string) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const formattedDate = dayjs(date).format('YYYY-MM-DD');

  const guessTimezone = dayjs.tz.guess();
  let zone = guessTimezone ?? 'Europe/Stockholm';

  if (dateTimezone) {
    zone = dateTimezone;
  }

  const startDate = dayjs
    .tz(formattedDate, zone)
    .set('hours', 5)
    .set('minute', 30)
    .set('second', 0)
    .utc()
    .format();

  const endDate = dayjs
    .tz(formattedDate, zone)
    .add(1, 'day')
    .set('hours', 5)
    .set('minute', 29)
    .set('second', 59)
    .utc()
    .format();

  return { startDate, endDate };
};

export const formatDate = (date: Date, dateTimezone: string, addHours: boolean, format: string) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  let zone = 'Europe/Stockholm';

  if (dateTimezone) {
    zone = dateTimezone;
  }

  if (addHours) {
    const { startDate } = dateToUTC(date, zone);
    return dayjs(startDate).tz(zone).format(format);
  } else {
    return dayjs(date).tz(zone).format(format);
  }
};

export const prevDate = (date) => {
  const prev = dayjs(date).subtract(1, 'day');

  return prev.toDate();
};

export const nextDate = (date, disableFuture) => {
  if (disableFuture && dayjs(date).isSame(dayjs().add(-1, 'day'), 'day')) return date;
  const next = dayjs(date).add(1, 'day');

  return next.toDate();
};

export const getToday = (dateTimezone?: string) => {
  const { startDate, endDate } = dateToUTC(dayjs().toDate(), dateTimezone);

  return {
    startToday: dayjs(startDate).toDate(),
    endToday: dayjs(endDate).toDate(),
    today: dayjs().toDate(),
  };
};

export const getYesterday = (dateTimezone?: string) => {
  const { startDate, endDate } = dateToUTC(dayjs().subtract(1, 'day').toDate(), dateTimezone);

  return { startYesterday: dayjs(startDate).toDate(), endYesterday: dayjs(endDate).toDate() };
};

export const getLastWeek = (dateTimezone?: string) => {
  const { startDate } = dateToUTC(dayjs().subtract(1, 'week').toDate(), dateTimezone);

  const { today } = getToday(dateTimezone);

  return { startLastWeek: dayjs(startDate).toDate(), endLastWeek: dayjs(today).toDate() };
};

export const getLastMonth = (dateTimezone?: string) => {
  const { startDate } = dateToUTC(dayjs().subtract(1, 'month').toDate(), dateTimezone);

  const { today } = getToday(dateTimezone);

  return { startLastMonth: dayjs(startDate).toDate(), endLastMonth: dayjs(today).toDate() };
};

export const getLastYear = (dateTimezone?: string) => {
  const { startDate } = dateToUTC(dayjs().subtract(1, 'year').toDate(), dateTimezone);

  const { today } = getToday(dateTimezone);

  return { startLastYear: dayjs(startDate).toDate(), endLastYear: dayjs(today).toDate() };
};

export const getThisYear = (dateTimezone?: string) => {
  const { startDate } = dateToUTC(dayjs().startOf('year').toDate(), dateTimezone);

  const { today } = getToday(dateTimezone);

  return { startThisYear: dayjs(startDate).toDate(), endThisYear: dayjs(today).toDate() };
};

export const getFirstAvailableDate = (dateTimezone?: string) => {
  const { startDate, endDate } = dateToUTC(dayjs('2017-04-01').toDate(), dateTimezone);

  return { startFirstAvailableDate: dayjs(startDate).toDate(), endFirstAvailableDate: endDate };
};
